import { Component, HostBinding, ViewEncapsulation } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'form-toggle-field',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
  styles: [
    `
      .form-toggle-field {
        display: flex;
        flex-direction: column;

        .toggle-label {
          pointer-events: none;
          top: var(--p-iftalabel-top);
          transition-property: all;
          transition-timing-function: ease;
          line-height: 1;
          font-size: var(--p-iftalabel-font-size);
          font-weight: var(--p-iftalabel-font-weight);
          inset-inline-start: var(--p-iftalabel-position-x);
          color: var(--p-iftalabel-color);
          transition-duration: var(--p-iftalabel-transition-duration);
          margin-bottom: 0.5rem;
        }
      }
    `,
  ],
  template: `
    <div *ngIf="field.props.label" class="toggle-label">
      {{
        field.props['translate']
          ? (field.props.label | translate)
          : field.props.label
      }}
    </div>
    <div style="display: flex;gap: 10px;">
      <p-toggleswitch
        [formControl]="formControl"
        [ariaLabelledBy]="field.id + '_label'"
      />
      <span [id]="field.id + '_label'">
        <ng-container
          *ngIf="
            formControl.getRawValue() &&
            isDefined(field?.props?.['labelTrueValue'])
          "
        >
          {{
            field.props['translate']
              ? (field.props['labelTrueValue'] | translate)
              : field.props['labelTrueValue']
          }}
        </ng-container>
        <ng-container
          *ngIf="
            !formControl.getRawValue() &&
            isDefined(field?.props?.['labelFalseValue'])
          "
        >
          {{
            field.props['translate']
              ? (field.props['labelFalseValue'] | translate)
              : field.props['labelFalseValue']
          }}
        </ng-container>
      </span>
    </div>
  `,
})
export class FormToggleFieldType extends FieldType<FieldTypeConfig> {
  @HostBinding('class')
  readonly cssClass = 'form-toggle-field';

  isDefined(value: undefined | string): boolean {
    return value !== undefined && value !== '';
  }
}
